import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useTyreReplacementUnlinkMutation = () =>
  useTypedMutation({
    mutationFn: (vehicle_tyre_replacement_id: number) => ApiInstance.post("/vehicle_tyre_replacements/unlink", { vehicle_tyre_replacement_id }, ENV.appointmentBaseURL),
    onSuccess: vehicle_tyre_replacement_id => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions?.length || !appointment.car?.tyres?.length) return;

      const tyreIdx = appointment.car.tyres.findIndex(t => t.replacements?.some(r => r.id === vehicle_tyre_replacement_id));
      if (tyreIdx < 0 || !appointment.car.tyres[tyreIdx].replacements?.length) return;

      const replacementIdx = appointment.car.tyres[tyreIdx].replacements.findIndex(r => r.id === vehicle_tyre_replacement_id);
      if (replacementIdx < 0) return;

      const intervention_id = appointment.car.tyres[tyreIdx].replacements[replacementIdx].intervention_id;
      if (intervention_id === null) return;

      const interventionIdx = appointment.interventions.findIndex(i => i.id === intervention_id);
      if (interventionIdx < 0) return;

      const replacement = { ...appointment.car.tyres[tyreIdx].replacements[replacementIdx], intervention_id: null };
      const interventions = appointment.interventions.with(interventionIdx, {
        ...appointment.interventions[interventionIdx],
        replacements: appointment.interventions[interventionIdx].replacements?.filter(r => r.id !== replacement.id)
      });
      const tyres = appointment.car.tyres.with(tyreIdx, {
        ...appointment.car.tyres[tyreIdx],
        replacements: appointment.car.tyres[tyreIdx].replacements.with(replacementIdx, replacement)
      });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, tyres }, interventions });
    }
  });
